jQuery(document).ready(function () {
    jQuery('.wm-measurementsCarousel__carousel').each(function () {
        jQuery(this).slick({
            slidesToShow: 1,
            dots: false,
            dotsClass: '',
            arrows: false,
            infinite: true,
            fade: true,
            adaptiveHeight: true,
        });
        jQuery(this).siblings('.wm-measurementsCarousel__navigation').find('.wm-measurementsCarousel__navigationCarousel').each(function () {
            jQuery(this).slick({
                slidesToShow: 4,
                prevArrow: jQuery(this).siblings('.wm-measurementsCarousel__navigationArrow.-prev'),
                nextArrow: jQuery(this).siblings('.wm-measurementsCarousel__navigationArrow.-next'),
                infinite: true,
                asNavFor: jQuery(this).parent().siblings('.wm-measurementsCarousel__carousel'),
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                        }
                    }
                ]
            });
        });
    });
});
